<template>
    <v-expansion-panels
        :disabled="checking"
    >
        <v-expansion-panel
            id="summary-mobile-accordion"
        >
            <v-expansion-panel-header
                class="title-branding"
                @click="goTo('summary')"
            >
                <div
                    class="d-flex justify-start align-center"
                >
                    <v-icon
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                        class="mr-2"
                        large
                    >
                        $mdiLegacyReviewSummary
                    </v-icon>
                    <h3
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        Summary
                    </h3>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content
                class="no-padding-accordion-panel"
            >
                <v-card
                    class="pa-0"
                    flat
                >
                    <summary-summary/>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel
            id="benefactor-mobile-accordion"
        >
            <v-expansion-panel-header
                class="title-branding"
                @click="goTo('benefactor')"
            >
                <div
                    class="d-flex justify-start align-center"
                >
                    <v-icon
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                        class="mr-2"
                        large
                    >
                        $mdiLegacyReviewBenefactor
                    </v-icon>
                    <h3
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        {{ getBenefactorLabel(client.benefactor_type) }} BeneFactor™
                    </h3>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content
                class="no-padding-accordion-panel"
            >
                <v-card
                    class="pa-0"
                    flat
                >
                    <summary-benefactor/>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel
            id="lpp-mobile-accordion"
        >
            <v-expansion-panel-header
                class="title-branding"
                @click="goTo('lpp')"
            >
                <div
                    class="d-flex justify-start align-center"
                >
                    <v-icon
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                        class="mr-2"
                        large
                    >
                        $mdiLegacyReviewLPP
                    </v-icon>
                    <h3
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        {{ getLppLabel(client.lpp_type) }} LPP™
                    </h3>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content
                class="no-padding-accordion-panel"
            >
                <v-card
                    class="pa-0"
                    flat
                >
                    <summary-lpp/>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>


        <v-expansion-panel
            id="estate_and_trustee_fees-mobile-accordion"
        >
            <v-expansion-panel-header
                class="title-branding"
                @click="goTo('estate_and_trustee_fees')"
            >
                <div
                    class="d-flex justify-start align-center"
                >
                    <v-icon
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                        class="mr-2"
                        large
                    >
                        $mdiLegacyReviewEstate
                    </v-icon>
                    <h3
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >

                        Estate Fees {{ summaryShortFallText }}
                    </h3>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content
                class="no-padding-accordion-panel"
            >
                <v-card
                    class="pa-0"
                    flat
                >
                    <summary-estate
                        v-if="client.value > 0"
                    />
                    <p
                        v-else
                        class="mx-4"
                    >
                        No information available
                    </p>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel
            id="mycover-mobile-accordion"
        >
            <v-expansion-panel-header
                class="title-branding"
                @click="goTo('mycover')"
            >
                <div
                    class="d-flex justify-start align-center"
                >
                    <v-icon
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                        class="mr-2"
                        large
                    >
                        $mdiLegacyReviewMyCover
                    </v-icon>
                    <h3
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        MyCover™
                    </h3>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content
                class="no-padding-accordion-panel"
            >
                <v-card
                    class="pa-0"
                    flat
                >
                    <summary-my-cover/>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel
            v-if="!clientView"
            id="advisor_wiifm-mobile-accordion"
        >
            <v-expansion-panel-header
                class="title-branding"
                @click="goTo('advisor_wiifm')"
            >
                <div
                    class="d-flex justify-start align-center"
                >
                    <v-icon
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                        class="mr-2"
                        large
                    >
                        $mdiLegacyReviewAdvisor
                    </v-icon>
                    <h3
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        Advisor WIIFM
                    </h3>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content
                class="no-padding-accordion-panel"
            >
                <v-card
                    class="pa-0"
                    flat
                >
                    <summary-advisor/>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
    import SummaryIcons from "./Tabs/Icons";
    import SummaryLpp from "./Tabs/Lpp";
    import SummaryMyCover from "./Tabs/MyCover";
    import SummarySummary from "./Tabs/Summary";
    import SummaryEstate from "./Tabs/Estate";
    import SummaryBenefactor from "./Tabs/Benefactor";
    import SummaryAdvisor from "./Tabs/Advisor";

    import MyCoverMixin from "../mycover";

    export default {
        name: "My-Cover-Mobile-Accordion",

        components: {
            SummaryIcons,
            SummaryLpp,
            SummaryMyCover,
            SummarySummary,
            SummaryEstate,
            SummaryBenefactor,
            SummaryAdvisor
        },

        mixins: [
            MyCoverMixin
        ],

        props: {
            'clientView': {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {}
        },

        methods: {
            goTo(location) {
                location = '#' + location + '-mobile-accordion';

                setTimeout(() => {
                    this.$vuetify.goTo(location, {
                        duration: 300,
                        offset: 0,
                        easing: 'easeInOutCubic',
                    });
                }, 300);
            }
        }
    }
</script>
